<template>
  <login-panel
    back-route-name="sign-in"
    class="external-login"
    xs
    :enable-footer-default-class="false"
  >
    <div class="external-login__logo">
      <img src="/static/imgs/lg-treetech.png" alt="Treetech logo" />
    </div>
    <div class="external-login__content">
      <div class="external-login__label">
        <label for="organizationId" class="external-login__label-text">
          {{ $t('login.organization-identifier') }}
        </label>
        <info-badge
          class="external-login__label-tooltip"
          boundary="window"
          placement="top"
          translation-key="login.organization-identifier-tooltip"
        />
      </div>
      <b-form-input
        id="organizationId"
        type="text"
        maxlength="100"
        @keypress="allowAlphaNumericsOnly"
        @input="makeInputLowerCase"
        :value="organizationId"
      />
      <b-button
        id="continue"
        variant="primary"
        :disabled="$v.organizationId.$invalid"
        class="external-login__btn-continue"
        @click="getExternalLoginUrl()"
      >
        {{ $t('actions.continue') }}
      </b-button>
    </div>
    <div slot="login-panel-footer">
      <div
        class="external-login__btn-copy-link"
        v-if="!$v.organizationId.$invalid"
      >
        <p role="button" @click="copyUrlToClipboard()">
          {{ $t('login.copy-link') }}
        </p>
        <i
          role="button"
          @click="copyUrlToClipboard()"
          aria-hidden="true"
          class="fas fa-link"
        />
        <info-badge
          class="external-login__link-tooltip"
          boundary="window"
          placement="top"
          translation-key="login.copy-link-tooltip"
        />
      </div>
    </div>
  </login-panel>
</template>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.external-login
  display: flex
  flex-direction: column
  max-width: 442px
  background-color: $color-white-100
  &__content
    margin-top: 10px
    display: flex
    flex-direction: column
    justify-content: center
    max-width: 100%
  &__label
    display: flex
    gap: 4px
  &__label-tooltip
    ::v-deep .info-badge__icon
      color: var(--color-gray-medium-dark)
  &__logo
    text-align: center
    height: 90px
    margin: 15px
    img
      height: 100%
      width: auto
  &__btn-continue
    margin-top: 20px
  &__btn-copy-link
    display: flex
    align-items: center
    justify-content: flex-end
    padding: 0 15px 10px 0
    border-top: 0px
    gap: 5px
    width: 100%
    color: var(--color-info)
    p
      margin: 0
</style>

<script>
import { required, alphaNum } from 'vuelidate/lib/validators';
import LoginPanel from '@/components/LoginPanel';
import InfoBadge from '@/components/icon/InfoBadge';
import AuthenticationService from '@/services/authentication';

export default {
  components: {
    LoginPanel,
    InfoBadge,
  },
  validations: {
    organizationId: {
      required,
      alphaNum,
    },
  },
  data() {
    return {
      organizationId: '',
    };
  },
  methods: {
    makeInputLowerCase(event) {
      this.organizationId = event.toLowerCase();
    },
    allowAlphaNumericsOnly(event) {
      if (/^[a-zA-Z0-9]$/.test(event.key)) {
        return;
      }

      event.preventDefault();
    },
    getExternalLoginUrl() {
      return AuthenticationService.getExternalLoginUrl(this.organizationId)
        .then(res => window.location.replace(res.data))
        .catch(() => this.$pushAlert({ code: 'ME092' }));
    },
    async copyUrlToClipboard() {
      let url = `${window.location.origin}/#${this.$route?.path}`;

      if (this.organizationId && this.organizationId !== '') {
        url += `?organizacaoId=${this.organizationId}`;
      }

      await navigator.clipboard.writeText(url);
    },
    getOrganizationIdFromQueryIfItExists() {
      const organizacaoIdQueryParam = this.$route?.query.organizacaoId;

      if (organizacaoIdQueryParam) {
        this.organizationId = organizacaoIdQueryParam.toLowerCase();
      }
    },
  },
  mounted() {
    this.getOrganizationIdFromQueryIfItExists();
  },
};
</script>
